/**
 * @generated SignedSource<<8f837346290a9ffb77d491c203e08093>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type SendDeclinedTimeRegEmailReminderInput = {
  receiverId?: string | null;
  receiverIds?: ReadonlyArray<string | null> | null;
  dateRange?: string | null;
  csrfToken?: string | null;
  socketClientId?: string | null;
  clientMutationId?: string | null;
};
export type sendDeclinedTimeRegEmailReminderMutation$variables = {
  input: SendDeclinedTimeRegEmailReminderInput;
};
export type sendDeclinedTimeRegEmailReminderMutation$data = {
  readonly sendDeclinedTimeRegEmailReminder: {
    readonly clientMutationId: string | null;
  } | null;
};
export type sendDeclinedTimeRegEmailReminderMutation = {
  variables: sendDeclinedTimeRegEmailReminderMutation$variables;
  response: sendDeclinedTimeRegEmailReminderMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "SendDeclinedTimeRegEmailReminderPayload",
    "kind": "LinkedField",
    "name": "sendDeclinedTimeRegEmailReminder",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "clientMutationId",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "sendDeclinedTimeRegEmailReminderMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "sendDeclinedTimeRegEmailReminderMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "3c04e281395277e3e45404201aba6a1d",
    "id": null,
    "metadata": {},
    "name": "sendDeclinedTimeRegEmailReminderMutation",
    "operationKind": "mutation",
    "text": "mutation sendDeclinedTimeRegEmailReminderMutation(\n  $input: SendDeclinedTimeRegEmailReminderInput!\n) {\n  sendDeclinedTimeRegEmailReminder(input: $input) {\n    clientMutationId\n  }\n}\n"
  }
};
})();

(node as any).hash = "e958a82be35077048b586c897be367c9";

export default node;
